export const ANALYTICS_EVENTS = {
  AUTH: {
    LOGIN_SUCCESS: 'auth_login_success',
    LOGIN_FAILED: 'auth_login_failed',
    LOGOUT: 'auth_logout',
    SIGNUP_STARTED: 'auth_signup_started',
    SIGNUP_COMPLETED: 'auth_signup_completed',
    SIGNUP_OTP_SENT: 'auth_signup_otp_sent',
    SIGNUP_OTP_VERIFIED: 'auth_signup_otp_verified',
    SIGNUP_OTP_RESENT: 'auth_signup_otp_resent',
    SIGNUP_CONTEXT_COMPLETED: 'auth_signup_context_completed',
    SIGNUP_DEMO_DATA_LOADED: 'auth_signup_demo_data_loaded',
    SIGNUP_DEMO_DATA_SKIPPED: 'auth_signup_demo_data_skipped',
    GOOGLE_SIGNUP_COMPLETED: 'auth_google_signup_completed',
    PASSWORD_RESET_REQUESTED: 'auth_password_reset_requested',
    PASSWORD_RESET_REQUEST_FAILED: 'auth_password_reset_request_failed',
    PASSWORD_RESET_PAGE_VIEWED: 'auth_password_reset_page_viewed',
    PASSWORD_RESET_LINK_INVALID: 'auth_password_reset_link_invalid',
    PASSWORD_RESET_COMPLETED: 'auth_password_reset_completed',
    PASSWORD_RESET_FAILED: 'auth_password_reset_failed',
    PASSWORD_UPDATED: 'auth_password_updated',
    SESSION_REFRESHED: 'auth_session_refreshed',
  },

  LEAD: {
    CREATED: 'lead_created',
    VIEWED: 'lead_viewed',
    UPDATED: 'lead_updated',
    DELETED: 'lead_deleted',
    STATUS_CHANGED: 'lead_status_changed',
    ASSIGNED: 'lead_assigned',
    CONVERTED_TO_CLIENT: 'lead_converted_to_client',
    LIST_VIEWED: 'lead_list_viewed',
    FILTERED: 'lead_filtered',
  },

  CLIENT: {
    CREATED: 'client_created',
    VIEWED: 'client_viewed',
    UPDATED: 'client_updated',
    STATUS_CHANGED: 'client_status_changed',
    ASSIGNED: 'client_assigned',
    LIST_VIEWED: 'client_list_viewed',
    FILTERED: 'client_filtered',
    TAB_VIEWED: 'client_tab_viewed',
  },

  DIET: {
    PLAN_CREATED: 'diet_plan_created',
    PLAN_UPDATED: 'diet_plan_updated',
    PLAN_SAVED: 'diet_plan_saved',
    PLAN_EXPORTED: 'diet_plan_exported',
    PLAN_SHARED: 'diet_plan_shared',
    TEMPLATE_IMPORTED: 'diet_template_imported',
    TEMPLATE_CREATED: 'diet_template_created',
    TEMPLATE_UPDATED: 'diet_template_updated',
    TEMPLATE_DELETED: 'diet_template_deleted',
    TEMPLATE_VIEWED: 'diet_template_viewed',
    TEMPLATE_LIST_VIEWED: 'diet_template_list_viewed',
    MEAL_ADDED: 'diet_meal_added',
    MEAL_REMOVED: 'diet_meal_removed',
    MEAL_EDITED: 'diet_meal_edited',
    UNDO: 'diet_undo',
    REDO: 'diet_redo',
    COPY: 'diet_copy',
    PASTE: 'diet_paste',
    PUBLISHED: 'diet_published',
    DAY_CLEARED: 'diet_day_cleared',
    DAY_STATUS_UPDATED: 'diet_day_status_updated',
    FIND_REPLACE: 'diet_find_replace',
  },

  FOOD: {
    CREATED: 'food_created',
    VIEWED: 'food_viewed',
    UPDATED: 'food_updated',
    DELETED: 'food_deleted',
    SEARCHED: 'food_searched',
    LIST_VIEWED: 'food_list_viewed',
    FILTERED: 'food_filtered',
    AI_NUTRITION_ESTIMATED: 'food_ai_nutrition_estimated',
  },

  VITALS: {
    RECORDED: 'vitals_recorded',
    BULK_RECORDED: 'vitals_bulk_recorded',
    UPDATED: 'vitals_updated',
    DELETED: 'vitals_deleted',
    CHART_VIEWED: 'vitals_chart_viewed',
  },

  SUBSCRIPTION: {
    CREATED: 'subscription_created',
    UPDATED: 'subscription_updated',
    CANCELLED: 'subscription_cancelled',
    PAYMENT_RECORDED: 'subscription_payment_recorded',
    VIEWED: 'subscription_viewed',
  },

  USER: {
    INVITED: 'user_invited',
    INVITE_RESENT: 'user_invite_resent',
    BLOCKED: 'user_blocked',
    UNBLOCKED: 'user_unblocked',
    PROFILE_UPDATED: 'user_profile_updated',
  },

  ROLE: {
    CREATED: 'role_created',
    UPDATED: 'role_updated',
    DELETED: 'role_deleted',
    VIEWED: 'role_viewed',
  },

  DASHBOARD: {
    VIEWED: 'dashboard_viewed',
    WIDGET_INTERACTED: 'dashboard_widget_interacted',
    FILTER_CHANGED: 'dashboard_filter_changed',
    DATE_RANGE_CHANGED: 'dashboard_date_range_changed',
    REFRESHED: 'dashboard_refreshed',
  },

  SETTINGS: {
    GENERAL_UPDATED: 'settings_general_updated',
    INTEGRATION_CONNECTED: 'settings_integration_connected',
    INTEGRATION_DISCONNECTED: 'settings_integration_disconnected',
  },

  COUNSELLING: {
    SCHEDULED: 'counselling_scheduled',
    VIEWED: 'counselling_viewed',
    COMPLETED: 'counselling_completed',
  },

  FOLLOWUP: {
    SCHEDULED: 'followup_scheduled',
    VIEWED: 'followup_viewed',
    COMPLETED: 'followup_completed',
  },

  HELP: {
    CENTER_VIEWED: 'help_center_viewed',
    SEARCHED: 'help_searched',
    ARTICLE_VIEWED: 'help_article_viewed',
    FEEDBACK_SUBMITTED: 'help_feedback_submitted',
    SUPPORT_CLICKED: 'help_support_clicked',
  },

  FEATURE: {
    SEARCH_USED: 'feature_search_used',
    EXPORT_USED: 'feature_export_used',
    BULK_ACTION_USED: 'feature_bulk_action_used',
    KEYBOARD_SHORTCUT_USED: 'feature_keyboard_shortcut_used',
    TOUR_STARTED: 'tour_started',
    TOUR_COMPLETED: 'tour_completed',
    TOUR_SKIPPED: 'tour_skipped',
    IMPERSONATION_STARTED: 'feature_impersonation_started',
    IMPERSONATION_ENDED: 'feature_impersonation_ended',
    ATTACHMENT_DOWNLOADED: 'feature_attachment_downloaded',
    ATTACHMENT_DELETED: 'feature_attachment_deleted',
    TRANSFORMATION_DELETED: 'feature_transformation_deleted',
    TRANSFORMATION_PUBLISHED: 'feature_transformation_published',
    NOTE_CREATED: 'feature_note_created',
  },
} as const;

type AuthEvent =
  (typeof ANALYTICS_EVENTS.AUTH)[keyof typeof ANALYTICS_EVENTS.AUTH];
type LeadEvent =
  (typeof ANALYTICS_EVENTS.LEAD)[keyof typeof ANALYTICS_EVENTS.LEAD];
type ClientEvent =
  (typeof ANALYTICS_EVENTS.CLIENT)[keyof typeof ANALYTICS_EVENTS.CLIENT];
type DietEvent =
  (typeof ANALYTICS_EVENTS.DIET)[keyof typeof ANALYTICS_EVENTS.DIET];
type FoodEvent =
  (typeof ANALYTICS_EVENTS.FOOD)[keyof typeof ANALYTICS_EVENTS.FOOD];
type VitalsEvent =
  (typeof ANALYTICS_EVENTS.VITALS)[keyof typeof ANALYTICS_EVENTS.VITALS];
type SubscriptionEvent =
  (typeof ANALYTICS_EVENTS.SUBSCRIPTION)[keyof typeof ANALYTICS_EVENTS.SUBSCRIPTION];
type UserEvent =
  (typeof ANALYTICS_EVENTS.USER)[keyof typeof ANALYTICS_EVENTS.USER];
type RoleEvent =
  (typeof ANALYTICS_EVENTS.ROLE)[keyof typeof ANALYTICS_EVENTS.ROLE];
type DashboardEvent =
  (typeof ANALYTICS_EVENTS.DASHBOARD)[keyof typeof ANALYTICS_EVENTS.DASHBOARD];
type SettingsEvent =
  (typeof ANALYTICS_EVENTS.SETTINGS)[keyof typeof ANALYTICS_EVENTS.SETTINGS];
type CounsellingEvent =
  (typeof ANALYTICS_EVENTS.COUNSELLING)[keyof typeof ANALYTICS_EVENTS.COUNSELLING];
type FollowupEvent =
  (typeof ANALYTICS_EVENTS.FOLLOWUP)[keyof typeof ANALYTICS_EVENTS.FOLLOWUP];
type FeatureEvent =
  (typeof ANALYTICS_EVENTS.FEATURE)[keyof typeof ANALYTICS_EVENTS.FEATURE];
type HelpEvent =
  (typeof ANALYTICS_EVENTS.HELP)[keyof typeof ANALYTICS_EVENTS.HELP];

export type AnalyticsEventName =
  | AuthEvent
  | LeadEvent
  | ClientEvent
  | DietEvent
  | FoodEvent
  | VitalsEvent
  | SubscriptionEvent
  | UserEvent
  | RoleEvent
  | DashboardEvent
  | SettingsEvent
  | CounsellingEvent
  | FollowupEvent
  | FeatureEvent
  | HelpEvent;
